<div class="PnCheckbox">
  <label class="PnCheckbox-label" data-test-container>
    <input
      class="PnCheckbox-field"
      [ngClass]="{ 'is-error': error }"
      type="checkbox"
      [name]="name"
      [checked]="checked"
      [disabled]="disabled"
      [value]="value"
      [(formControl)]="control"
      data-test-field
    />

    <span *ngIf="label" class="PnCheckbox-text" data-test-label>
      {{ label }}
    </span>
  </label>
</div>
